import React from 'react';
import { useTranslation } from 'react-i18next';

const TermsOfUse = () => {
  const { t } = useTranslation();
  return (
    <div className="terms-container">
      <h1 className="terms-title">{t('header.terms')}</h1>
      <p><strong>{t('header.terms_effective')}</strong> 03 May 2025</p>
      <p>{t('header.terms_intro1')}<br/>{t('header.terms_intro2')}<br/>{t('header.terms_intro3')}</p>
      <p>{t('header.terms_intro4')}</p>

      <h2>{t('header.terms_1_title')}</h2>
      <p><strong>{t('header.terms_1_age')}</strong> {t('header.terms_1_age_text')}</p>
      <p><strong>{t('header.terms_1_reg')}</strong> {t('header.terms_1_reg_text')}</p>

      <h2>{t('header.terms_2_title')}</h2>
      <p>{t('header.terms_2_intro')}</p>
      <ul>
        <li>{t('header.terms_2_list1')}</li>
        <li>{t('header.terms_2_list2')}</li>
        <li>{t('header.terms_2_list3')}</li>
      </ul>
      <p>{t('header.terms_2_lawful')}</p>
      <p><strong>{t('header.terms_2_thirdparty_title')}</strong> {t('header.terms_2_thirdparty')}</p>
      <p><strong>{t('header.terms_2_moderation_title')}</strong> {t('header.terms_2_moderation')}</p>

      <h2>{t('header.terms_3_title')}</h2>
      <p>{t('header.terms_3_intro')}</p>
      <ul>
        <li>{t('header.terms_3_list1')}</li>
        <li>{t('header.terms_3_list2')}</li>
        <li>{t('header.terms_3_list3')}</li>
        <li>{t('header.terms_3_list4')}</li>
        <li>{t('header.terms_3_list5')}</li>
      </ul>

      <h2>{t('header.terms_4_title')}</h2>
      <p>{t('header.terms_4_text')}</p>

      <h2>{t('header.terms_5_title')}</h2>
      <p>{t('header.terms_5_text1')}</p>
      <p>{t('header.terms_5_text2')}</p>
      <p>{t('header.terms_5_text3')}</p>
      <p>
        {t('header.terms_5_privacy1')}{' '}
        <a href="/privacy" target="_blank" rel="noopener noreferrer" style={{color: '#568259', textDecoration: 'underline'}}>{t('header.privacy')}</a>.
      </p>

      <h2>{t('header.terms_6_title')}</h2>
      <p>{t('header.terms_6_text')}</p>

      <h2>{t('header.terms_7_title')}</h2>
      <p>{t('header.terms_7_text')}</p>

      <h2>{t('header.terms_8_title')}</h2>
      <p>{t('header.terms_8_text1')}</p>
      <p>{t('header.terms_8_text2')} <a href="mailto:info@upyachat.com" style={{color: '#568259', textDecoration: 'underline'}}>info@upyachat.com</a>.</p>
      <p>{t('header.terms_8_text3')}</p>

      <h2>{t('header.terms_9_title')}</h2>
      <p>{t('header.terms_9_text1')}</p>
      <p>{t('header.terms_9_text2')}</p>

      <h2>{t('header.terms_10_title')}</h2>
      <p>{t('header.terms_10_text')}</p>

      <h2>{t('header.terms_11_title')}</h2>
      <p>{t('header.terms_11_text1')} <a href="mailto:info@upyachat.com" style={{color: '#568259', textDecoration: 'underline'}}>info@upyachat.com</a>.</p>
    </div>
  );
};

export default TermsOfUse; 